import Vue from 'vue';
import VueTheMask, { mask } from 'vue-the-mask'; // import InputFacade from 'vue-input-facade'
// Vue.use(InputFacade)

Vue.use(VueTheMask);
Vue.directive('mask', mask); // import VueMask, { VueMaskDirective } from 'v-mask'
// Vue.use(VueMask)
// Vue.directive('mask', VueMaskDirective)